import React from "react";
import "./Loader.css"

function Loader() {
    return (
        <div>
            <img src="https://cdn.dribbble.com/users/13754/screenshots/6628859/egg-beater-loader.gif" alt="loader" />
        </div>
    )
}

export default Loader